module.exports = __webpack_public_path__ + "img/bg-round-fff.00ea2139.svg";